import { Reveal } from "./Motion";

// Editorial two-column block: heading left, content right.
export default function Split({ label, title, children, id, className = "", testid }) {
  return (
    <section id={id} className={`wrap grid gap-8 border-t border-ink/20 py-14 md:py-20 lg:grid-cols-12 ${className}`} data-testid={testid}>
      <Reveal className="lg:col-span-5">
        {label && <p className="label mb-4">{label}</p>}
        <h2 className="display h-md md:text-[2.6rem]">{title}</h2>
      </Reveal>
      <Reveal delay={0.08} className="space-y-5 text-[17px] leading-relaxed text-mute lg:col-span-6 lg:col-start-7">
        {children}
      </Reveal>
    </section>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="border-t border-ink/20">
      {items.map((t) => (
        <li key={t} className="flex gap-4 border-b border-ink/20 py-3 text-ink">
          <span className="mt-2.5 h-1.5 w-1.5 shrink-0 bg-accent" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}
